import { render, staticRenderFns } from "./batchingView.vue?vue&type=template&id=e33217c6&"
import script from "./batchingView.vue?vue&type=script&lang=js&"
export * from "./batchingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports